let _ = require('lodash');
let priceActions = require('../order/price');
let { thenWithErrorHandling } = require('../../helpers/errorHandler');
let utils = require('../../helpers/utils');

module.exports = {
    getDraftOrder (args, state, output, { context, locator }) {
        let role = state.get(['user', 'role']);

        if (role !== 'client') {
            output.error({ error: 'role not client' });
            return;
        }

        let api = locator.resolve('api');
        let request = api.getUserDraftOrder( context, locator );
        request
            .then((response) => {
                let code = _.get(response, 'status.code');
                if (code !== 200) {
                    output.error({ error: code });
                    return;
                }
                let { selectedParameters, availableParameters, price, id, isNeedToConfirmDataChanged, typeId } =
                    _.get(response, 'content');
                output.success({ selectedParameters, availableParameters, price, id, isNeedToConfirmDataChanged, typeId });
            })
            .catch((error) => output.error({ error }));
    },

    hasDraftOrderLoaded (args, state, output) {
        let orderId = state.get(['order', 'draft', 'id']);

        if (orderId) {
            output.yes({ orderId });
            return;
        }
        output.no();
    },

    archiveOrder ({ orderId }, state, output, { locator, context }) {
        let API = locator.resolve('api');

        let request = API.archiveOrder(context, locator, { orderId });
        thenWithErrorHandling(
            request,
            (data) => data,
            output);
    },

    setShouldRestoreFromLocalStorage (shouldRestore) {
        return (args, state) => state.set(['order', 'shouldRestoreFromLocalStorage'], shouldRestore);
    },

    shouldRestoreFromLocalStorage (args, state, output) {
        let shouldRestore = state.get(['order', 'shouldRestoreFromLocalStorage']);

        if (shouldRestore) {
            output.yes();
        } else {
            output.no();
        }
    },

    fillOrderCreationParameters ({ selectedParameters }, state, output, { context, locator }) {
        if (context.isServer) {
            return;
        }
        let window = locator.resolve('window');
        let serialized = window.localStorage.getItem('local_draft');

        let localChanges = null;
        if (serialized) {
            try {
                localChanges = JSON.parse(serialized);
            } catch (e) {
            }
        }

        selectedParameters = {
            parameters: selectedParameters,
        };

        if(localChanges) {
            selectedParameters.paymentTypeId = _.get(localChanges, 'selectedPaymentTypeId');
            selectedParameters.necessaryDocumentsIds = _.map(_.get(localChanges,'necessaryDocuments.addOrRemove', []),
                'documentTypeId');
        }

        output({ selectedParameters });
    },

    removeSavedSelectedParams (args, state, output, { context, locator }) {
        if (context.isServer) {
            return;
        }
        let window = locator.resolve('window');
        window.localStorage.removeItem('selected_params');
    },

    getSelectedParamsFromState (args, state, output) {
        let selectedParameters = priceActions.getSelectedParameters(state);
        output.success({ selectedParameters });
    },

    createOrder ({ selectedParameters }, state, output, { context, locator }) {
        let api = locator.resolve('api');
        let request = api.postOrderParameters(context, locator, { selectedParameters });
        request
            .then((response) => {
                let code = _.get(response, 'status.code');
                if (code === 401) {
                    output.unauthorized();
                    return;
                }
                if (code !== 201) {
                    output.error({ error: code });
                    return;
                }
                let orderData = _.get(response, 'content');
                output.success({ orderData });
            })
            .catch((error) => output.error({ error }));
    },

    setShouldCreateOrderAfterLogin (value) {
        return (args, state, output, { context, locator }) => {
            if (context.isServer) {
                return;
            }
            let window = locator.resolve('window');

            if (value) {
                window.localStorage.setItem('should_create_order_after_login', 'yes');
            } else {
                window.localStorage.removeItem('should_create_order_after_login');
            }
        };
    },

    shouldCreateOrderAfterLogin (args, state, output, { context, locator }) {
        if (context.isServer) {
            output.no();
            return;
        }
        let window = locator.resolve('window');
        let value = window.localStorage.getItem('should_create_order_after_login');

        if (value === 'yes') {
            output.yes();
            return;
        }

        let localDraft = window.localStorage.getItem('local_draft');
        if (localDraft) {
            output.yes();
            return;
        }

        output.no();
    },

    orderCreatedRedirect ({ orderData }, state, output, { context }) {
        let location = getOrderCreatedRedirectLocation(orderData.id || '', state);
        context.redirect(utils.patchQueryWithUtm(location, state));
    },

    orderCreatedLocationRedirect ({ orderData }, state) {
        let location = getOrderCreatedRedirectLocation(orderData.id || '', state);
        window.location = location;
    },

    setOrderLocationToState (statePath) {
        return ({ orderId }, state) => {
            let orderLocation = getOrderCreatedRedirectLocation(orderId || '', state);
            state.set(statePath, orderLocation);
        };
    }
};

function getOrderCreatedRedirectLocation (orderId, state) {
    let role = state.get(['user', 'role']);
    let pageName = 'account';
    if (role === 'manager') {
        pageName = 'manager';
    }
    return `/${pageName}/orders/${orderId}`;
}



// WEBPACK FOOTER //
// ./actions/order/index.js